import { NftList } from '@components/NftList/NftList'
import { Titlebar } from '@components/Titlebar/Titlebar'
import { useCurrentWallet, useNftBalances } from '@plug-core/state'
import useBalances from '@plug-core/hooks/useBalances'
import { Stack } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const NftsOverview = () => {
  const { nftsLoading, loadNfts } = useBalances()
  const { t } = useTranslation()

  return (
    <Stack flex={1} spacing={2} mt={2} mx={2}>
      <Titlebar
        title={t('discover.tabs.nfts.title')}
        refreshAction={loadNfts}
        isRefreshing={nftsLoading}
      />
      <NftList />
    </Stack>
  )
}
